import React from "react";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import GavelIcon from "@material-ui/icons/Gavel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import { SpeakerControls } from "./SpeakerControls";
import { AccordionActions } from "@material-ui/core";
import { replaceTag } from "../../../../helpers/tag.helper";

export function AgendaItem(props) {
  const { rowStyle, textStyle, titleStyle, title, active, styleWrapper, text, status, showSpeakerControl, collapsible, closed, clientKey,settings } = props;
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = () => {
    if ((collapsible && showSpeakerControl && active) || (collapsible && text)) setExpanded(!expanded);
  };
  let exp = !collapsible && text ? true : expanded;



  return (
    <div style={{ ...rowStyle }}>
      <Accordion
        style={{
          background: "transparent",
          boxShadow: "none",
          minHeight: "auto",
          padding: "0px 10px",
        }}
        expanded={exp}
        onChange={handleChange}
      >
        <AccordionSummary
          className="agenda-row"
          style={{ margin: 0, padding: 0, minHeight: "auto" }}
          expandIcon={collapsible && (text || (showSpeakerControl && active)) ? <ExpandMoreIcon style={{ color: titleStyle.color }} /> : null}
          aria-controls="panel-agenda-content"
        >
          <div style={{ margin: !collapsible ? "0px" : undefined }}>
            {showSpeakerControl && closed ? (
              <div style={{ ...titleStyle, opacity: 0.8 }}>
                <EventLabel2 name="AgendaClosed" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
              </div>
            ) : null}
            <div style={titleStyle}>{title}</div>
            {!collapsible ? (
              <div>
                {/*     {styleWrapper} */}
                <div
                  className={"agenda-text-" + status}
                  style={textStyle}
                  dangerouslySetInnerHTML={{
                    __html: replaceTag(text, clientKey),
                  }}
                />
              </div>
            ) : null}
            {!collapsible && showSpeakerControl ? (
              <div style={{ marginTop: 10, display: "flex" }}>
                <SpeakerControls {...props} />
              </div>
            ) : null}
          </div>
        </AccordionSummary>
        {collapsible ? (
          <AccordionDetails style={{ padding: 0 }}>
            {/*   {styleWrapper} */}
            <div className={"agenda-text-" + status} style={textStyle} dangerouslySetInnerHTML={{ __html: replaceTag(text, clientKey) }} />
          </AccordionDetails>
        ) : null}
        {collapsible && showSpeakerControl ? (
          <AccordionActions style={{ padding: 0 }}>
            <SpeakerControls {...props} />
          </AccordionActions>
        ) : null}
      </Accordion>
    </div>
  );
}
